<template>
  <div>
    <v-overlay v-if="loadingData" class="text-center">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
      <p>Cargando Actividad</p>
    </v-overlay>
    <v-card style="top: 70px; z-index: 1; position: sticky">
      <v-card-text>
        <v-row>
          <v-col md="6" cols="12">
            <v-autocomplete
              label="Actividad"
              v-model="rvaDepto"
              @input="onSelectDepto"
              :items="departamentos"
            ></v-autocomplete>
          </v-col>
          <v-col md="6" cols="12">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date"
                  label="Fecha Seleccionada"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <!-- :allowedDates="allowedDates" -->
              <v-date-picker
                v-model="date"
                @change="updateSelectedDate()"
                @update:picker-date="pickerUpdate($event)"
                no-title
                @input="menu = false"
                scrollable
              >
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col md="8" cols="12" v-if="rvaDepto" class="mt-n6">
            Seleccione un Espacio (Bahia,Cancha,Instructor)
            <v-chip-group class="mx-2" column>
              <template v-for="(bahia, index) in comp_bahias">
                <v-chip
                  :key="index"
                  @click="selectSlot(index)"
                  v-bind:class="[selectedSlot == index ? 'primary' : '']"
                  >{{ bahia.Name }}</v-chip
                >
              </template>
            </v-chip-group>
          </v-col>
          <v-col md="4" cols="12" v-if="rvaDepto" class="mt-n6">
            <div v-if="rangeSelected !== false">
              <v-btn
                color="primary"
                @click="
                  indexSheetForm++;
                  createDialog = true;
                "
                dark
                block
              >
                Reservar selección
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row>
      <v-col md="12" cols="12" v-if="rvaDepto" class="mt-4">
        <ActivityTimes
          @editClick="editTTReserva"
          :creationMode="creationMode"
          :reservasData="reservas"
          :slotsNumber="slotsNumber"
          :selectedSlot="selectedSlot"
          :showAll="showAll"
          :selectedDate="input_date"
          :key="indexActivityTeeSheet"
          @cleanTimesRange="cleanTimesRange"
          @selectTimesRange="selectTimesRange"
          :times="times"
        ></ActivityTimes>
      </v-col>
      <v-col md="12" cols="12" v-if="!rvaDepto" class="text-center">
        <h2>Selecione una actividad para ver el tee sheet</h2>
        <v-alert
      border="top"
      color="red lighten-2"
      dark
    >
      Este modulo desaparecerá y sera remplazado por actividades v2
    </v-alert>
      </v-col>
    </v-row>
    <v-dialog
      v-model="createDialog"
      fullscreen
      persistent
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="createDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Reserva de actividades</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="padding:14px">
          <BookingActivityForm
            :loadindAction="loadindAction"
            :dataTimes="dataTimes"
            :maxPlayers="maxPlayers"
            :rvaDepto="rvaDepto"
            :grupos="grupos"
            :Concierges="Concierges"
            :grupal="resGroup"
            :selectedDate="input_date"
            @successData="successData"
            :key="indexSheetForm"
            :selectedT="rangeSelected"
          ></BookingActivityForm>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="editDialog"
      fullscreen
      persistent
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="editDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Edición de reserva</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items> </v-toolbar-items>
        </v-toolbar>
        <v-card-text style="padding:14px">
          <BookingActivityEditForm
            :slotsNumber="slotsNumber"
            :grupos="grupos"
            :Concierges="Concierges"
            @successData="successData"
            :tarifaCombo="tarifaCombo"
            :daysRules="daysRules"
            :editData="editData"
            :editMode="editMode"
            :key="indexSheetFormEdit"
            :maxPlayers="maxPlayers"
            :rvaDepto="rvaDepto"
          ></BookingActivityEditForm>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import ActivityTimes from "../../MainComponents/ActivityTimes.vue";
import "../../../assets/css/custom.css";
import "../../../assets/css/listTeeSheet.css";
import "../../../assets/css/sideBar.css";
import TarifasClass from "../../../clases/Tarifa.js";
import Reserva from "../../../clases/Reserva.js";
import Cliente from "../../../clases/Cliente.js";
import BookingActivityForm from "./BookingActivityForm.vue";
import BookingActivityEditForm from "./BookingActivityEditForm.vue";

export default {
  name: "teeSheetTT",
  components: {
    ActivityTimes,
    BookingActivityForm,
    BookingActivityEditForm,
  },
  data() {
    return {
      grupos: [],
      Concierges: [],
      createDialog: false,
      editDialog: false,
      resGroup: false,
      indexSheetForm: 0,
      indexSheetFormEdit: 0,
      menu: false,
      date: moment().format("YYYY-MM-DD"),
      rvaDepto: null,
      loadingData: false,
      slotsNumber: 1,
      intervalTimes: 60,
      selectedSlot: -1,
      maxPlayers: 4,
      loadindAction: false,
      editMode: false,
      editData: [],
      //olddata
      creationMode: true,
      rangeSelected: false,
      Totales: {},
      indexActivityTeeSheet: 1,
      availableDates: [],
      listadoTarifas: [],
      Horarios: [],
      subcategorias: [],
      gruposCliente: [],
      showAll: true,
      hoteles: [],
      confirmBook: false,
      input_date: moment(),
      actualDate: moment(),
      actualListener: "",
      prefered: true,
      forceRecomputeCounter: 0,
      // Confirm:"",
      selectedPriceIndex: "",
      selectedTime: "",
      playersNumber: 1,
      cartRiderName: "",
      addOn: { cartRider: "", golfClub: "", transport: "" },
      hoyos: "",
      tiposJuego: [],
      temporadas: [],
      tarifas: [],
      tarifaGlobal: [],
      AllTarifas: [],
      times: [],
      reservas: [],
      cartRiders: [],
      daysRules: [],
      tarifaCombo: [],
      initTime: new moment("07:00", "HH:mm"),
      endTime: new moment("22:00", "HH:mm"),
      startHour: "07:00:00",
      endHour: "22:00:00",
      configTime: {},
      intervalo: 10,
      dataTimes: [],
      errors: {
        time: false,
        players: false,
        code: false,
      },
      highlighted: {
        dates: [
          // Highlight an array of dates
          new Date(moment()),
          //new Date(2020, 0, 17),
          //new Date(2020, 0, 18)
        ],
      },
    };
  },
  props: ["isHotel", "isWeb", "hideMenu"],
  methods: {
    async getTarifarios() {
      let tarifarios = await TarifasClass.getMixTarifasCombo(this.rvaDepto);
      tarifarios.forEach((element) => {
        element.value = element.Id;
        element.text = element.Nombre;
      });
      this.tarifaCombo = tarifarios;
    },
    async getConcierges() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Concierge"
      );
      if (!data.exists()) {
        return false;
      }
      let concierges = Object.entries(data.val());
      let conciergesData = [];
      concierges.forEach(function(element) {
        conciergesData.push({
          id: element[0],
          ...element[1],
        });
      });
      this.Concierges = conciergesData;
    },
    async getUserGroups() {
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("PDV_GruposCliente", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
      ]);

      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      let gps = [];
      if (document) {
        document.forEach((doc) => {
          if (doc.gps) {
            let grupos = Object.entries(doc.gps);
            grupos.forEach((element) => {
              if (element[1]) {
                gps.push({
                  name: element[0],
                });
              }
            });
            this.grupos = gps;
          }
        });
      }
    },
    selectSlot(index) {
      this.cleanTimesRange();
      if (index == this.selectedSlot) {
        this.selectedSlot = -1;
      } else {
        this.selectedSlot = index;
      }
    },
    onSelectDepto() {
      this.init();
    },
    updateSelectedDate() {
      this.loadingData = true;
      this.selectDate(this.date);
      //this.loadingData = false;
    },
    async editTTReserva(id) {
      let reserva = await Reserva.getById(id);
      let cuentas = Object.entries(reserva.Cuentas);
      reserva.Cuentas = cuentas.map((doc) => {
        return { indexCuenta: doc[0], ...doc[1] };
      });
      this.editData = reserva;
      this.editDialog = true;
      this.editMode = true;
      this.indexSheetFormEdit++;
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.bookNow(data);
        
      } else if (doAction == "EDIT") {
        this.editReserva(data);
      }
    },
    pickerUpdate(val) {
      let totalDay = moment(val, "YYYY-MM").daysInMonth();
      let weekDay = [];

      let disable_dates = [];
      let open_dates = [];

      this.daysRules.forEach((element) => {
        if (element.data === false) {
          disable_dates.push(element.date, "YYYY-MM-DD");
        } else {
          open_dates.push(element.date);
        }
      });

      let availableDates = [];

      let monthNow = moment().format("M");
      let monthSelected = moment(val).format("M");
      let day;

      if (monthNow == monthSelected) day = moment().format("D");
      else day = 1;

      for (let i = day; i <= totalDay; i++) {
        let date = moment()
          .month(val.split("-")[1] - 1)
          .date(i)
          .format("YYYY-MM-DD");
        if (
          !weekDay.includes(moment(date).day()) &&
          !disable_dates.includes(date)
        ) {
          if (date >= moment().format("YYYY-MM-DD")) {
            availableDates.push(date);
          }
        }

        if (weekDay.includes(moment(date).day()) && open_dates.includes(date)) {
          if (date >= moment().format("YYYY-MM-DD")) {
            availableDates.push(date);
          }
        }
      }
      this.availableDates = availableDates;
      //this.allowedDates();
    },

    closeDialog() {},
    /*allowedDates(a) {
        return this.availableDates.includes(a);
    },*/
    cleanTimesRange() {
      this.stepProcess = 1;
      this.rangeSelected = false;
    },
    selectTimesRange(times) {
      this.rangeSelected = times;
      let initTim;
      let endTime;
      if (times.length == 1) {
        initTim = new moment(times[0].time, "HH:mm");
        endTime = new moment(times[0].endTime, "HH:mm");
      } else {
        initTim = new moment(times[0].time, "HH:mm");
        endTime = new moment(times[1].time, "HH:mm");
      }

      let auxDate = initTim;
      let timesData = [];

      var i;
      /*para cada uno de los horarios armados se asignan los datos necesarios*/
      for (i = 0; auxDate.format("HH:mm") < endTime.format("HH:mm"); i++) {
        let intervalInMinutes = moment.duration(this.intervalTimes).asMinutes();
        let intervalo = intervalInMinutes || 60;
        
        let horarioTime = "";
        let modalidad = "";

        /*this.tarifas.forEach((tarifa) => {
          tarifa.arrayPrecios.forEach((modalidad) => {
            modalidad.horarios.forEach((horario) => {
              let endCompTime = new moment(
                auxDate.format("HH:mm:ss"),
                "HH:mm:ss"
              ).add(intervalo, "minutes");
              if (
                horario.data.HoraInicio <= auxDate.format("HH:mm:ss") &&
                horario.data.HoraTermino >= endCompTime.format("HH:mm:ss")
              ) {
                horarioTime = horario.id;
              }
            });
          });
        });*/

        let timeData = {
          horarioTime: horarioTime,
          modalidad: modalidad,
          time: auxDate.format("HH:mm"),
        };
        auxDate = auxDate.add(intervalo, "minutes");
        (timeData.timeEnd = auxDate.format("HH:mm")), timesData.push(timeData);
      }
      let HorariosTimeData = [];
      timesData.forEach((time) => {
        if (
          this.$pgsHelper.getById(HorariosTimeData, "horario", time.horarioTime)
        ) {
          HorariosTimeData[
            this.$pgsHelper.getById(
              HorariosTimeData,
              "horario",
              time.horarioTime
            ).idx
          ].times.push(time);
        } else {
          HorariosTimeData.push({
            horario: time.horarioTime,
            times: [time],
          });
        }
      });

      this.dataTimes = HorariosTimeData;

      let totalUSD = 0;
      let totalMXN = 0;

      HorariosTimeData.forEach((horario) => {
        horario.times.length;

        let Horas = 0;
        let MediasHoras = 0;

        Horas = Math.floor(horario.times.length / 2);
        MediasHoras = horario.times.length - Horas * 2;

        horario.Horas = Horas;
        horario.MediasHoras = MediasHoras;

        horario.HorasPrecio = 0;

        horario.MediasHorasPrecio = 0;

        let hModalidad = this.$pgsHelper.getById(
          this.tarifaPrice,
          "id",
          "01HOR"
        );
        let mModalidad = this.$pgsHelper.getById(
          this.tarifaPrice,
          "id",
          "30MIN"
        );

        let hPrecio = this.$pgsHelper.getById(
          hModalidad.Horarios,
          "id",
          horario.horario
        );

        let mPrecio = this.$pgsHelper.getById(
          mModalidad.Horarios,
          "id",
          horario.horario
        );
        (horario.HorasModalidad = hModalidad.id),
          (horario.MediasHorasModalidad = mModalidad.id);
        horario.HorasPrecio = Horas * hPrecio.PcoVen;
        horario.HorasPrecioMoneda = hPrecio.Moneda;
        horario.MediasHorasPrecio = MediasHoras * mPrecio.PcoVen;
        horario.MediasHorasMoneda = hPrecio.Moneda;
        let cambio = this.tiposCambio.TC.USD;
        if (horario.HorasPrecioMoneda == "MXN") {
          totalUSD += Math.ceil(horario.HorasPrecio / cambio);
          totalMXN += horario.HorasPrecio;
        } else if (horario.HorasPrecioMoneda == "USD") {
          totalUSD += horario.HorasPrecio;
          totalMXN += parseFloat(horario.HorasPrecio * cambio);
        }

        if (horario.MediasHorasMoneda == "MXN") {
          totalUSD += Math.ceil(horario.MediasHorasPrecio / cambio);
          totalMXN += horario.MediasHorasPrecio;
        } else if (horario.MediasHorasMoneda == "USD") {
          totalUSD += horario.MediasHorasPrecio;
          totalMXN += parseFloat(horario.MediasHorasPrecio * cambio);
        }

        this.Totales = {
          totalUSD: totalUSD,
          totalMXN: totalMXN,
        };
      });
    },
    async init() {
      this.loadingData = true;
      try {
        let endMonthDate = moment()
          .endOf("month")
          .format("YYYY-MM-DD");
        let startMonthDate = moment()
          .startOf("month")
          .format("YYYY-MM-DD");
        await this.getReservasByMonth("", startMonthDate, endMonthDate);
        await this.getTemporadas();
        await this.getTiposJuego();
        await this.getTarifarios();
        await this.getSubcategoria();
        await this.getHorarios();
        this.getAddons();
        this.getDaysRules();
        this.getHoteles();
        this.loadingData = false;
      } catch (e) {
        this.loadingData = false;
      }
    },

    async getSubcategoria() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/" + this.rvaDepto + "/SubCategorias"
      );
      if (!data.exists()) {
        return false;
      }
      let arrayHoteles = Object.entries(data.val());

      arrayHoteles.forEach((element) => {
        this.$pgsHelper.log(element);
        this.subcategorias.push({
          id: element[0],
          key: element[0],
          text: element[1].Nombre,
          value: element[0],
          ...element[1],
        });
      });
    },
    async getHorarios() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/" + this.rvaDepto + "/Horarios"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayHorarios = Object.entries(data.val());
      var $this = this;
      arrayHorarios.forEach(function(element) {
        $this.Horarios.push({ id: element[0], ...element[1] });
      });
    },
    validateClientForm() {
      let valid = true;
      if (this.clientAdd.nombre == "") {
        valid = false;
      }

      if (this.clientAdd.apellidos == "") {
        valid = false;
      }

      if (this.clientAdd.email == "") {
        valid = false;
      }

      return valid;
    },
    setPlayerData(player) {
      this.data_clientes.forEach((element) => {
        if (element.Id == player.IdCliente) {
          player.name = element.getNombreCompleto();
          player.email = element.Correo;
        }
      });
    },

    async getHoteles() {
      //obtiene el listado de hoteles afiliados
      await this.$store.getters.getFirebaseApp.database.queryBuilderListener(
        "RVA/Mayoristas/Coleccion",
        null,
        (snapshot) => {
          this.hoteles = [];
          let arrayHoteles = Object.entries(snapshot.val());
          arrayHoteles.forEach((element) => {
            this.hoteles.push({ id: element[0], ...element[1] });
          });
        }
      );
    },
    editPlayer(index) {
      this.editPlayers.edit = !this.editPlayers.edit;
      this.editPlayers.playerIdx = index;
    },
    deletePlayer(index) {
      this.players.splice(index, 1);
      this.playersNumber = this.players.length;
      this.forceRecomputeCounter++;
    },
    toggleModal() {
      this.modalOpen = !this.modalOpen;
    },
    getTarifaData(id) {
      let itemIndex = this.$_.findIndex(this.tarifas, { Id: id });
      if (itemIndex >= 0) {
        this.tarifas[itemIndex].idxPlayers = [];
      }

      return this.tarifas[itemIndex];
    },
    addCartRider() {
      if (this.cartRiderName !== "") {
        this.cartRiders.push({ name: this.cartRiderName });
        this.cartRiderName = "";
        if (this.transportation) {
          this.getTransportationData();
        }
      } else {
        this.$swal({
          icon: "error",
          title: "Cart Rider Name is required",
          text: "",
        });
      }
    },
    deleteCartRider(index) {
      this.cartRiders.splice(index, 1);
      this.getTransportationData();
    },
    changePlayersNumber() {
      this.resetSelect();
      //this.players= [{name:'',email:'',phone:'',golfClub:false,side:"right",genero:'Man',shaft:'regular'}];
      if (this.players.length < this.playersNumber) {
        var i;
        for (i = this.players.length; i < this.playersNumber; i++) {
          this.players.push({
            name: "",
            email: "",
            phone: "",
            golfClub: false,
            side: "right",
            genero: "Man",
            shaft: "regular",
            tarifa: "",
            isClient: false,
            IdCliente: " ",
          });
        }
      } else if (this.players.length > this.playersNumber) {
        for (i = this.playersNumber; i < this.players.length; i) {
          this.players.pop();
        }
      }
      if (this.transportation) {
        this.getTransportationData();
      }
      this.forceRecomputeCounter++;
    },

    changeTrans(value) {
      //this.transportation = value;
      if (value == true) {
        this.transModal = true;
      } else {
        /*if(this.selectedPriceIndex === ""){
                this.$swal(
                    'Selecciona un horario',
                    'Selecciona un horario de juego antes de solicitar transportacion ',
                    'error'
                )

                document.getElementsByName('trans').forEach((element =>{
                    element.checked = false;
                }))
        }else if(this.transportation && this.selectedPriceIndex !== ""){
            if(this.isHotel){
                this.getTransportationData();
            }

        }*/
        this.Session = "";
        this.ApiToken = "";
        this.TotalTrans = 0;
        this.RowId = "";
        this.RsvaId = "";
        this.DuracionViaje = "";
        this.HtlPickup = "";
        this.PCGCPickup = "";
        //this.Confirm ="";
        this.transportation = value;
        this.tranindx++;
        this.$swal(
          "No se transportara a los jugadores",
          "La transportacion al campo de golf  no sera incluida en esta reserva ",
          "error"
        );
      }
    },
    changeHoyos() {
      this.resetSelect();
      (this.selectedTime = ""), (this.selectedPrice = ""), this.compIndex++;
      this.getTarifas();
    },
    changeAsGuest() {
      var $this = this;
      if (this.checkAsGuest == true) {
        var pNumber = 1;
        $this.players.forEach(function(element, index) {
          if (index != 0 && element.name == "") {
            element.name = "Guest " + pNumber;
            element.email = "guest@guestmail.com";
            pNumber++;
          }
        });
      } else {
        $this.players.forEach(function(element, index) {
          if (index != 0) {
            element.name = "";
            element.email = "";
          }
        });
      }
    },
    showPrefered() {
      this.resetSelect();
      if (this.prefered) {
        /* this.times.forEach((element)=>{
                   element.prefered = false;
           });*/
        this.times.forEach((element, index) => {
          if (element.personas > 0 && element.prefered == true) {
            this.times[index - 1].preferedClass = true;
            element.preferedClass = true;
            this.times[index + 1].preferedClass = true;
          }
        });
      } else if (this.prefered === false) {
        this.times.forEach((element) => {
          element.preferedClass = true;
        });
      }
    },
    setSelectedTime(key, time, idTarifa, prefered) {
      //alert(key + ' ' + time + ' ' + total);

      this.selectedPriceIndex = key;
      this.selectedTime = time;
      this.selectedTarifa = idTarifa;
      this.isPreferedTime = prefered;

      this.$nextTick(() => {
        document.getElementById("dataClient").scrollIntoView();
      });
    },
    selectDate(arg) {
      //let oldDate= this.input_date.format('YYYY-MM-DD');
      //this.killListener(oldDate);
      this.input_date = moment(arg);
      this.resetSelect();
      this.selectedTime = "";
      this.selectedPrice = "";
      this.tarifario = "";
      this.tarifa = "";
      this.listadoTarifas = [];
      this.tarifas = [];
      this.buildTimesData();
      this.$forceUpdate();
      this.loadingData = false;
    },
    setInitialDate() {
      this.input_date.format("YYYY-MM-DD");
      let aux = false;
      this.daysRules.forEach((element) => {
        if (element.data.Abre && element.data.Cierra) {
          if (this.input_date.format("YYYY-MM-DD") === element.date) {
            this.initTime = new moment(element.data.Abre, "HH:mm:ss");
            this.endTime = new moment(element.data.Cierra, "HH:mm:ss");
            aux = true;
          }
        }
      });

      if (!aux) {
        this.initTime = this.configTime.initTime;
        this.endTime = this.configTime.endTime;
      }
    },
    killListener(date) {
      const ref = this.$store.getters.getFirebaseApp.database.ref(
        "RVA/Reservas/" + this.rvaDepto + "/" + date
      );
      this.$store.getters.getFirebaseApp.database.off(ref);
    },
    selectPaid(value) {
      this.$store.commit("setTypePaid", value);
      this.getTarifas();
    },
    resetSelect() {
      this.stepProcess = 1;
      this.rangeSelected = false;
      this.indexActivityTeeSheet++;
      this.selectedPriceIndex = "";
      this.isPreferedTime = false;

      document.getElementsByName("trans").forEach((element) => {
        element.checked = false;
      });
      this.$store.commit("setPriceSelected", 0);
    },

    async getTarifas() {
      let idTemporada = "";
      this.temporadas.forEach((element) => {
        if (
          moment(element.FechaInicio).format("YYYY-MM-DD") <=
            this.input_date.format("YYYY-MM-DD") &&
          moment(element.FechaTermino).format("YYYY-MM-DD") >=
            this.input_date.format("YYYY-MM-DD")
        ) {
          idTemporada = element.id;
        }
      });
      if (this.tarifa == "") {
        return false;
      }

      let tarifas = await TarifasClass.getMixTarifasByTarifarioParse(
        this.tarifario,
        idTemporada,
        this.rvaDepto,
        this.Horarios,
        this.temporadas,
        this.tiposJuego,
        this.input_date.day()
      );

      this.tarifas = [this.$pgsHelper.getById(tarifas, "id", this.tarifa)];

      this.buildTimesData();
      this.loadingTarifas = false;
      this.$forceUpdate();
      this.forceRecomputeCounter++;
    },
    async getTarifasByPlayer(index) {
      let idTemporada = 0;
      let idTarifa = this.players[index].tarifa.id;

      /*  Ubica la temporada actual segun sus fechas de inicio y fin */
      this.temporadas.forEach((element) => {
        if (
          moment(element.FechaInicio).format("YYYY-MM-DD") <=
            this.input_date.format("YYYY-MM-DD") &&
          moment(element.FechaTermino).format("YYYY-MM-DD") >=
            this.input_date.format("YYYY-MM-DD")
        ) {
          idTemporada = element.id;
        }
      });

      let tarifas_array = [];
      let tarifas_parse = [];
      this.$pgsHelper.log(idTarifa);
      let global = await this.$store.getters.getFirebaseApp.firestore
        .doc("Golf_Tarifas/" + idTarifa + "/Temporadas/" + idTemporada)
        .get();
      let tarifa_global = { Id: global.ref.id, ...global.data() };
      tarifa_global.Accesos = "Global";

      tarifas_array.push(tarifa_global);

      var aux = 1;
      tarifas_array.forEach((element) => {
        let arrayHorarios = Object.entries(element.Horarios);
        arrayHorarios.forEach((horario) => {
          let arrayjuegos = Object.entries(horario[1].TiposJuego);
          arrayjuegos.forEach((juego) => {
            if (juego[0] == this.hoyos) {
              let tarifaObj = {};
              tarifaObj.Id = horario[0];
              tarifaObj.Precio = juego[1].Precio;
              tarifaObj.Moneda = juego[1].Moneda;
              tarifaObj.Horario = horario[1];
              tarifaObj.Accesos = [element.Accesos];
              tarifaObj.TarifaId = this.players[index].tarifa.id;
              tarifaObj.TarifaNombre = this.players[index].tarifa.text;
              tarifaObj.id = aux;

              if (element.Subcategoria) {
                tarifaObj.SubCategoria = element.Subcategoria;
              }

              aux++;
              tarifas_parse.push(tarifaObj);
            }
          });
        });
      });

      tarifas_parse.forEach((element, index) => {
        if (
          element.Horario.HoraTermino < this.actualDate.format("HH:mm:ss") &&
          this.actualDate.format("YYYY-MM-DD") ===
            this.input_date.format("YYYY-MM-DD")
        ) {
          element.pasado = true;
          tarifas_parse.splice(index, 1);
        }
      });
      /* ordena la tarifa por hora de inicio */
      tarifas_parse.sort(function compare(a, b) {
        return (
          moment(a.Horario.HoraInicio, "HH:mm") -
          moment(b.Horario.HoraInicio, "HH:mm")
        );
      });
      /*Asigna las tarifas globales y para hoteles o web*/
      this.players[index].Tarifas = [];
      let idHorarioTarifa = 0;
      this.tarifas.forEach((element) => {
        if (element.id === this.selectedTarifa) {
          idHorarioTarifa = element.Id;
        }
      });

      tarifas_parse.forEach((element) => {
        if (element.Id == idHorarioTarifa) {
          this.players[index].Tarifas = element;
        }
        if (
          element.Horario.HoraTermino >=
            moment(this.selectedTime, "HH:mm").format("HH:mm") &&
          element.Horario.HoraInicio <=
            moment(this.selectedTime, "HH:mm").format("HH:mm")
        ) {
          this.players[index].Tarifas = element;
        }
      });
      this.$pgsHelper.log(idHorarioTarifa);
      this.$pgsHelper.log(tarifas_parse);
      this.$pgsHelper.log(this.players);

      this.$forceUpdate();
      this.forceRecomputeCounter++;
    },
    getServicesIncludes() {},
    goRoute(routePath) {
      this.$router.push({ path: routePath });
    },
    async testRealTime() {
      const data = await this.$store.getters.getFirebaseApp.database
        .ref("Configuracion/Reservas/EmailCCO")
        .once("value");
      this.$pgsHelper.log(data.val());
    },
    setTransData(data) {
      this.Session = data.Session;
      this.ApiToken = data.ApiToken;
      this.TotalTrans = data.TotalTrans;
      this.RowId = data.RowId;
      this.RsvaTransId = data.RsvaTransId;
      this.rawDuracionViaje = data.DuracionViaje;
      this.DuracionViaje = moment(data.DuracionViaje, "HH:mm:ss").format(
        "HH [Hrs] : mm [Min]."
      );
      if (data.typeTransportation == 1) {
        this.HtlPickup =
          data.HtlPickup.format(" DD-MMM-YYYY ") +
          moment(data.htime).format("HH [Hrs] : mm [Min].");
        this.PCGCPickup =
          data.PCGCPickup.format(" DD-MMM-YYYY ") +
          moment(data.gtime).format("HH [Hrs] : mm [Min].");
      } else if (data.typeTransportation == 2) {
        this.HtlPickup =
          data.HtlPickup.format(" DD-MMM-YYYY ") +
          moment(data.htime).format("HH [Hrs] : mm [Min].");
        this.PCGCPickup = "NA";
      } else if (data.typeTransportation == 3) {
        this.HtlPickup = "NA";
        this.PCGCPickup =
          data.PCGCPickup.format(" DD-MMM-YYYY ") +
          moment(data.gtime).format("HH [Hrs] : mm [Min].");
      }

      this.transportation = true;
      this.transModal = false;
    },
    async getTransportationData() {
      /*
        Obiene la informacion de la transportacion para la reserva
        */
      let data = {
        PaxNumber: this.players.length + this.cartRiders.length,
        hotelCode: this.isHotel
          ? this.$route.params.user.tokenResult.claims.Code
          : this.index_hotel,
        Prefered: this.isPreferedTime,
        Fecha:
          this.input_date.format("YYYY-MM-DD") +
          "_" +
          moment(this.selectedTime, "HH:mm").format("HH:mm:ss"),
      };
      this.loadingData = true;
      //var getTransportation = this.$store.getters.getFirebaseApp.fba.call('Golf-Reservas-transportationAvailability');
      return await this.$store.getters.getFirebaseApp.fba
        .call("Golf-Reservas-transportationAvailability", data, {})
        .then((result) => {
          this.Session = result.data.data.Session;
          this.ApiToken = result.data.data.ApiToken;
          this.TotalTrans =
            this.typePaid === 1
              ? this.playersNumber >= 4
                ? 0
                : this.addOn.transport.Precio
              : this.playersNumber >= 2
              ? 0
              : this.addOn.transport.Precio;
          this.RowId = result.data.data.RowId;
          this.RsvaTransId = result.data.data.RsvaTransId;
          this.rawDuracionViaje = result.data.data.DuracionViaje;
          this.DuracionViaje = moment(
            result.data.data.DuracionViaje,
            "HH:mm:ss"
          ).format("HH [Hrs] : mm [Min].");
          this.HtlPickup = moment(
            result.data.data.HtlPickup,
            "YYYY-MM-DD_HH:mm:ss"
          ).format(" DD-MMM-YYYY HH:mm ");
          this.PCGCPickup = moment(
            result.data.data.PCGCPickup,
            "YYYY-MM-DD_HH:mm:ss"
          ).format(" DD-MMM-YYYY HH:mm ");
          //this.Confirm= result.data.data.Confirm;
          this.loadingData = false;
        })
        .catch((error) => {
          this.$pgsHelper.log(error);
        });
    },
    async getTiposJuego() {
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/" + this.rvaDepto + "/Modalidades"
      );
      if (data.exists()) {
        let arrayTipos = Object.entries(data.val());
        var $this = this;
        arrayTipos.forEach(function(element) {
          $this.tiposJuego.push({
            id: element[0],
            codigo: element[1]["Codigo"],
            nombre: element[1]["Nombre"],
          });
          $this.hoyos = element[0];
        });
      }
    },
    async getTemporadas() {
      /*
        Obtiene las temporadas existentes en la db
        */
      const data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "RVA/Tarifas/" + this.rvaDepto + "/Temporadas"
      );

      if (!data.exists()) {
        return false;
      }
      let arrayTarifas = Object.entries(data.val());
      arrayTarifas.forEach((element) => {
        if (element[1].Activo) {
          this.temporadas.push({ id: element[0], ...element[1] });
        }
      });
    },
    async getAddons() {
      /*
        Obtiene las temporadas existentes en la db
        */
      let addons = this.$store.getters.getRVACatalogo;
      this.addOn.cartRider = addons.GOLFRIDDER;
      this.addOn.golfClub = addons.GOLFCLUB;
      this.addOn.transport = addons.TRANSPORT;
    },
    async getReservas() {
      /*
            Se obtiene las disponibilidad por dia y la cantidad de personas reservadas en esos dias
        */

      let date = this.input_date.format("YYYY-MM-DD");
      this.killListener(this.actualListener);
      this.$store.getters.getFirebaseApp.database.queryBuilderListener(
        "RVA/Reservas/" + this.rvaDepto + "/" + date,
        null,
        (snapshot) => {
          if (snapshot.exists()) {
            this.reservas = [];

            let arrayReservas = snapshot.val();
            this.totalPlayers = 0;
            this.reservas = Reserva.parseAvailabilityDataTopTracer(
              arrayReservas
            );
            
          } else {
            this.reservas = [];
            this.totalPlayers = 0;
          }
          this.totalReservas = this.reservas.length;
          this.showPrefered();
        }
      );
      this.actualListener = date;
    },
    async getReservasByMonth(month, start, end) {
      const database = this.$store.getters.getFirebaseApp.database;
      const ref = database.ref("RVA/Reservas/" + this.rvaDepto + "/");
      database.off(ref);
      database.queryBuilder(
        "RVA/Reservas/" + this.rvaDepto + "/",
        [database.orderByKey(), database.startAt(start), database.endAt(end)],
        (snapshot) => {
          if (snapshot.exists()) {
            this.reservasMonth = [];

            let arrayReservas = snapshot.val();

            Object.entries(arrayReservas).forEach(([index, element]) => {
              let dataReserva = Object.entries(element);

              dataReserva.forEach((reservaInfo) => {
                let dataRes = Object.entries(reservaInfo[1]);

                dataRes.forEach((res) => {
                  this.reservasMonth.push({ Date: index, ...res });
                });
              });
            });
          } else {
            this.reservasMonth = [];
          }
        }
      );

      //this.actualListener = date;
    },
    async getDaysRules() {
      this.$store.getters.getFirebaseApp.database.queryBuilderListener(
        "RVA/Configuracion/" + this.rvaDepto + "/Calendario",
        null,
        (snapshot) => {
          if (snapshot.exists()) {
            this.daysRules = [];
            if (snapshot.val().Fechas_Especiales) {
              let arrayCalendar = Object.entries(
                snapshot.val().Fechas_Especiales
              );
              arrayCalendar.forEach((element) => {
                this.daysRules.push({ date: element[0], data: element[1] });
              });

              //ordena las reglas por fecha
              this.daysRules.sort(function compare(a, b) {
                return a.date - b.date;
              });
              //si la fecha inicial esta entre las reglas como un dia cerrado aumenta un dia
              this.daysRules.forEach((element) => {
                if (
                  element.date == this.input_date.format("YYYY-MM-DD") &&
                  element.data == false
                ) {
                  this.input_date.add(1, "days");
                }
              });
            } else {
              this.configTime.initTime = new moment(this.startHour, "HH:mm:ss");
              this.configTime.endTime = new moment(this.endHour, "HH:mm:ss");
              this.daysRules = [];
            }
          } else {
            this.configTime.initTime = new moment(this.startHour, "HH:mm:ss");
            this.configTime.endTime = new moment(this.endHour, "HH:mm:ss");
            this.daysRules = [];
          }
          this.configTime.initTime = new moment(
            snapshot.val().Hora_Apertura,
            "HH:mm:ss"
          );
          this.configTime.endTime = new moment(
            snapshot.val().Hora_Cierre,
            "HH:mm:ss"
          );
          //configuracion para bahias e intervalos
          this.slotsNumber = snapshot.val().Salidas;
          this.maxPlayers = snapshot.val().MaxPlayers;
          this.intervalTimes = snapshot.val().Intervalo_TeeTimes;
          this.buildTimesData();
          this.getTarifas();
        }
      );
    },
    async buildTimesData() {
      await this.getReservas();
      /*
            Genera el array conteniendo cada horario disponible para reserva en un intervalo de 10 minutos desde la hora inicial y la hora final
        */
      this.initTime = "";
      this.endTime = "";
      this.setInitialDate();
      let initTim = new moment(this.initTime.format("HH:mm"), "HH:mm");
      let endTime = new moment(this.endTime.format("HH:mm"), "HH:mm");

      let auxDate = initTim;
      this.times = [];

      var i;
      /*para cada uno de los horarios armados se asignan los datos necesarios*/
      for (i = 0; auxDate.format("HH:mm") < endTime.format("HH:mm"); i++) {
        let intervalInMinutes = moment.duration(this.intervalTimes).asMinutes(); //.duration().asMinutes()
        let intervalo = intervalInMinutes || 60;

        var idTarifa;
        var precio;
        var idTarifaGlobal = "";
        var precioGlobal = "";
        let personas = 0;
        let privado = false;
        let prefered = false;
        let Moneda = "";
        /* Se asigna la tarifa y el precio */
        /*this.tarifas.forEach((tarifa) => {
          tarifa.arrayPrecios.forEach((modalidad) => {
            modalidad.horarios.forEach((horario) => {
              if (modalidad.id == this.hoyos) {
                if (
                  horario.data.HoraInicio <= auxDate.format("HH:mm:ss") &&
                  horario.data.HoraTermino >= auxDate.format("HH:mm:ss")
                ) {
                  idTarifa = horario.internalId;
                  precio = horario.PcoVen;
                  Moneda = horario.Moneda;
                }
              }
            });
          });
        });*/
        /*Se asigna la tarifa global y el precio global*/
        /*this.tarifaGlobal.forEach(tarifa => {
                tarifa.arrayPrecios.forEach(modalidad=>{
                    modalidad.horarios.forEach((horario)=>{
                        if(modalidad.id == this.hoyos){
                             if(horario.data.HoraInicio <= auxDate.format('HH:mm:ss') && horario.data.HoraTermino >= auxDate.format('HH:mm:ss')  ){
                                idTarifaGlobal = horario.internalId;
                                precioGlobal = horario.PcoVen;
                            }
                        }

                    })
                })
            })*/
        let players = [];
        let reservaData = [];
        /*en caso de que tengan reservas en ese Horario y dia seleccionado se agregan a los datos*/
        /*this.reservas.forEach((element) => {
          let time = new moment(element.time, "HH:mm:ss");
          if (time.format("HH:mm") == auxDate.format("HH:mm")) {
            privado = element.Privado ? element.Privado : false;
          }
        });*/

        /* se agregan al array*/

        let timeData = {
          time: auxDate.format("HH:mm"),
          tarifaId: idTarifa,
          tarifaIdGlobal: idTarifaGlobal,
          precioGlobal: precioGlobal,
          precio: precio,
          personas: personas,

          privado: privado,
          players: players,
          prefered: prefered,
        };
        auxDate = auxDate.add(intervalo, "minutes");
        (timeData.timeEnd = auxDate.format("HH:mm")), this.times.push(timeData);
      }
    },
    validation() {
      var valid = true;

      if (this.selectedPriceIndex === "") {
        valid == false;
        this.errors.time = true;
      } else {
        this.errors.time = false;
      }
      let aux = 0;

      if (this.players[0].name == "") {
        aux++;
      }

      if (aux > 0) {
        valid = false;
        this.errors.players = true;
      } else {
        this.errors.players = false;
      }

      if (this.typePaid === 1 && this.promotionalCode === "") {
        valid = false;
        this.errors.code = true;
      } else {
        this.errors.code = false;
      }
      this.$pgsHelper.log(this.transportation);
      if (this.transportation === "") {
        valid = false;
        this.errors.trans = true;
      } else {
        this.errors.trans = false;
      }

      return valid;
    },
    async bookNow(reservationData) {
      
      this.loadindAction = true;
      let ruta = reservationData.grupal
        ? "RVA-Reservas-reservarGrupo"
        : "RVA-Reservas-crearReserva";
      await this.$store.getters.getFirebaseApp.fba
        .call(ruta, reservationData)
        .then((result) => {
          if (result.data.ok) {
            this.loadindAction = false;
            this.createDialog = false;
            //this.indexSheetForm++;
          } else {
            this.loadindAction = false;
            this.$swal(
              "Error guardando la reserva",
              result.data.error,
              "error"
            );
          }
        })
        .catch((error) => {
          this.loadindAction = false;
          this.$swal(`Request failed: ${error}`);
        });
    },
    editReserva(datos) {
      let validation = datos ? true : this.validation();
      if (validation) {
        let reservationData = datos ? datos : this.buildReservationData();

        this.$swal({
          title: "¿Deseas editar esta reserva?",
          text: "Los datos de la reserva seran modificados",
          icon: "warning",
          allowOutsideClick: false,
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Editar",
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            //var addReserva = this.$store.getters.getFirebaseApp.fba.call('RVA-Reservas-crearReserva');
            return await this.$store.getters.getFirebaseApp.fba
              .call("RVA-Reservas-editarReserva", reservationData)
              .then(function(result) {
                return result;
              })
              .catch((error) => {
                this.$swal.showValidationMessage(`Request failed: ${error}`);
              });
          },
        }).then((result) => {
          if (result.value) {
            if (result.value.data.ok) {
              this.$swal({
                title: "¡¡Guardado",
                text: "Tu reservación se edito correctamente",
                icon: "success",
              }).then(() => {
                this.loadindAction = false;
                this.editDialog = false;
              });

              //this.$emit('changeIndex');
            } else {
              this.$swal(
                "Error guardando la reserva",
                result.value.data.error,
                "error"
              );
            }
          }
        });
      }
    },
  },
  computed: {
    comp_bahias() {
      let bahias = [];
      for (let index = 1; index <= this.slotsNumber; index++) {
        bahias.push({ Name: "B" + index });
      }
      return bahias;
    },
    departamentos() {
      let deptos = [];
      let departamentos = this.$store.getters.getDepartamentos;
      departamentos.forEach((dep) => {
        if (dep.id != "Golf") {
          (dep.text = dep.Nombre), (dep.value = dep.id);
          deptos.push(dep);
        }
      });
      return deptos;
    },
    compRes() {
      let sortReservations = this.$_.orderBy(this.reservas, "time", "asc");
      if (this.name_filter !== "") {
        let filter = this.$_.map(sortReservations, (o) => {
          if (
            o.rvsData[0].Nom.toUpperCase().includes(
              this.name_filter.toUpperCase()
            )
          )
            return o;
        });
        filter = this.$_.without(filter, undefined);
        return filter;
      }
      return sortReservations;
    },
    Addons() {
      /*
        Obtiene las temporadas existentes en la db
        */
      let AddOn = {};
      let addons = this.$store.getters.getRVACatalogo;

      AddOn.cartRider = addons.GOLFRIDDER; //arrayExt;
      AddOn.golfClub = addons.GOLFCLUB; //arrayGb;
      AddOn.transport = addons.TRANSPORT;
      AddOn.roundGolf = addons.GOLFROUND;
      return AddOn;
    },
    tarifaPrice() {
      let preciosTarifa = [];
      /*this.tarifas.forEach((tarifa) => {
        tarifa.arrayPrecios.forEach((modalidad) => {
          let modalidadData = {
            id: modalidad.id,
            Nombre: modalidad.data.nombre,
            Horarios: [],
          };
          modalidad.horarios.forEach((horario) => {
            modalidadData.Horarios.push(horario);
          });
          preciosTarifa.push(modalidadData);
        });
      });*/
      return preciosTarifa;
    },
    typePaid() {
      return this.$store.getters.getTypePaid;
    },

    computedStep() {
      let step = 3;
      let stepTrans = 4;
      let stepExtraInfo = 5;
      if (this.isHotel) {
        if (this.typePaid == 2) {
          step = 5;
          stepExtraInfo = 6;
        } else if (this.typePaid == 1) {
          step = 6;
          stepExtraInfo = 7;
        } else if (this.typePaid == "") {
          step = 5;
          stepExtraInfo = 6;
        }
      }

      return {
        stepTime: step,
        stepExtraInfo: stepExtraInfo,
        stepTrans: stepTrans,
      };
    },
    disabledDates() {
      let disable_dates = [];
      let open_dates = [];

      this.daysRules.forEach((element) => {
        if (element.data === false) {
          disable_dates.push(new Date(moment(element.date, "YYYY-MM-DD")));
        } else {
          open_dates.push(new Date(moment(element.date, "YYYY-MM-DD")));
        }
      });

      return {
        to: new Date(moment().subtract(1, "days")),
        dates: disable_dates,
        customPredictor: function(date) {
          let aux = true;
          let dateFormat =
            date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate();
          if (date.getDay() == 1) {
            open_dates.forEach((element) => {
              let openDate =
                element.getFullYear() +
                "-" +
                element.getMonth() +
                "-" +
                element.getDate();
              if (openDate == dateFormat) {
                aux = false;
              }
            });

            return aux;
          }
        },
      };
    },
    tiposCambio() {
      let cambio = this.$store.getters.getTiposCambios;
      return cambio[0];
    },
    data_clientes() {
      let data = Cliente.getClientsList();

      data.forEach((cliente) => {
        cliente.value = cliente.Id;
        cliente.text = cliente.getNombreCompleto();
      });
      return data;
    },
  },
  async mounted() {
    await this.getUserGroups();
    await this.getConcierges();
    await this.getTarifarios();
    this.showPrefered();
    //this.testRealTime();
  },
  async beforeMount() {
    //this.getClientes();
    //this.MainDepartamento = localStorage.getItem("TopDepartment");
    if (this.isHotel) {
      this.prefered = true;
    }
    if (this.isWeb) {
      this.$store.commit("setTypePaid", 2);
    }

    if (!this.isWeb && !this.isHotel) {
      this.$store.commit("setTypePaid", 2);
      this.isAdmin = true;
    }

    this.$emit("useNav", true);
    this.$store.commit("setGlobalPrice", 190);
    //this.init();
  },
  created() {
    setInterval(() => {
      let fecha = new moment();
      this.actualDate = fecha; //.format("YYYY-MM-DD HH:mm:ss");
    }, 1000);
  },
  watch: {
    // whenever question changes, this function will run
    players: function() {
      this.$forceUpdate();
    },
  },
};
</script>

<style>
@media only screen and (max-width: 600px) {
  .paidDescription {
    display: none !important;
  }
}

.vdp-datepicker__calendar {
  width: 100% !important;
}

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (max-width: 768px) {
  .paidDescription {
    display: none !important;
  }
}
</style>
